module.exports = __webpack_public_path__ + "img/bucket-circle-1.75be2b4d.svg";